import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    createOrUpdateGenericLog,
    getPageGenericLogs,
} from '../GenericLogEndPoint'

export const usePageGenericLogs = (
    requestorId,
    type,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {genericLogKeys} = QueryKeyManager(
        QueryKeyTypes.genericLog,
        requestorId,
    )

    return useQuery({
        queryKey: genericLogKeys.page({
            type,
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageGenericLogs(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useGenericLogCRUD = (type, requestorId) => {
    const {genericLogKeys} = QueryKeyManager(
        QueryKeyTypes.genericLog,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateGenericLog(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                // if (
                //     type === QueryCRUDTypes.create ||
                //     type === QueryCRUDTypes.update
                // ) {
                //     showNotification(
                //         severityNotification.success,
                //         'Generic Log Update Successfully !!',
                //     )
                // } else if (type === QueryCRUDTypes.delete) {
                //     showNotification(
                //         severityNotification.success,
                //         'Deletion performed successfully!!',
                //     )
                // }
            }
        },
    })
}
